import { ComponentProps, FC, Fragment, ReactNode } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { useTheme } from '@forma/forma-ui-theme';
import { Button, ButtonsContainer } from '@forma/forma-ui-kit';
import { useTrialDaysText } from '@/hooks/useTrialDays';

import styles from './demo-buttons.module.css';

const lkUrl = process.env.LK_URL;
const demoUrl = process.env.DEMO_URL;

interface DemoButtonsProps {
  startButton?: ComponentProps<typeof Button<'a'>>,
  demoButton?: ComponentProps<typeof Button<'a'>>
  buttonsClassName?: string,
  noticeClassName?: string,
  notice?: ReactNode
}

const DemoButtons: FC<DemoButtonsProps> = ({ startButton = {}, demoButton = {}, buttonsClassName, noticeClassName, notice }) => {
  const { t } = useTranslation();
  const trialDays = useTrialDaysText();
  const { viewport, lang } = useTheme();
  const isPhone = viewport === 'phone';

  return (
    <Fragment>
      <ButtonsContainer className={classNames(styles.buttons, buttonsClassName)}>
        <Button
          as={Link}
          viewStyle="primary"
          size="m"
          className={styles.button}
          fullWidth={isPhone}
          reversed
          {...startButton}
          href={startButton.href ?? `${lkUrl}/register?lng=${lang}`}
        >
          {startButton?.children ?? t('start_free')}
        </Button>
        <Button
          as={Link}
          viewStyle="secondary"
          size="m"
          className={classNames(styles.button, styles.secondary)}
          fullWidth={isPhone}
          reversed
          target={!demoButton.href ? '_blank' : undefined}
          rel={!demoButton.href ? 'noopener noreferrer' : undefined}
          {...demoButton}
          href={demoButton.href ?? demoUrl ?? ''}
        >
          {demoButton?.children ?? t('request_demo')}
        </Button>
      </ButtonsContainer>

      <div className={classNames(styles.notice, noticeClassName)}>
        {notice ?? `Бесплатно ${trialDays}. Карта не требуется.`}
      </div>
    </Fragment>
  );
};

export default DemoButtons;
